import './WelcomeMessageBanner.sass';

import React, { FC, useEffect, useMemo } from 'react';

import { Block, Button } from '$uikit';
import router from '$navigation/router';
import { WELCOME_MESSAGE } from '$shared/constants/pages';
import { useCurrentUserInfo, useLastActivity, useTranslator } from '$hooks';
import { WelcomeMessageBannerProps } from '$core/Chat/WelcomeMessageBanner/WelcomeMessageBanner.interface';
import { useDispatch, useSelector } from 'react-redux';
import { imActions, imHistorySelector, imInfoLoadingSelector } from '$store/im';
import { RootState } from '$store/rootReducer';
import { WelcomeMessageType } from '$store/im/interface';
import { MessageModel } from '$store/models';

export const WelcomeMessageBanner: FC<WelcomeMessageBannerProps> = ({ peerId }) => {
  const t = useTranslator();
  const history = useSelector((state: RootState) => imHistorySelector(state, peerId));
  const isLoading = useSelector((root: RootState) => imInfoLoadingSelector(root, peerId));
  const { online } = useLastActivity(peerId);
  const currentUser = useCurrentUserInfo();
  const isModel = currentUser.verified === 2;
  const dispatch = useDispatch();
  const welcomeMessage = useSelector(
    (state: RootState) => state.im.welcomeMessage[WelcomeMessageType.FOLLOWER],
  );

  useEffect(() => {
    if (welcomeMessage.loadingStatus !== 'loaded') {
      dispatch(imActions.loadWelcomeMessage(WelcomeMessageType.FOLLOWER));
    }
  }, []);

  const canShow = useMemo(() => {
    const h: MessageModel[] = Object.values(history);
    return (
      !isLoading &&
      h.length &&
      h.every((item) => item.isInbox) &&
      !online &&
      isModel &&
      welcomeMessage.loadingStatus === 'loaded' &&
      !welcomeMessage.isEnabled
    );
  }, [history, online, isModel, welcomeMessage, isLoading]);

  return canShow ? (
    <Block className="WelcomeMessageBanner">
      <div className="WelcomeMessageBanner__title">
        {t('welcome_message_banner_title')}
      </div>
      <div className="WelcomeMessageBanner__desc">{t('welcome_message_banner_desc')}</div>
      <div className="WelcomeMessageBanner__button">
        <Button size="medium" onClick={() => router.navigate(WELCOME_MESSAGE)}>
          {t('welcome_message_banner_button')}
        </Button>
      </div>
    </Block>
  ) : null;
};
